var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.02944 0 0 3.50335 0 7.8237C0 12.144 7.07367 19 9 19C10.9257 19 18 12.144 18 7.8237C18 3.50335 13.9706 0 9 0ZM9 11.4146C6.71815 11.4146 4.86917 9.80675 4.86917 7.8237C4.86917 5.84009 6.71815 4.23277 9 4.23277C11.2812 4.23277 13.1308 5.84009 13.1308 7.8237C13.1308 9.80675 11.2812 11.4146 9 11.4146Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.93131070ad00cf3c9733e0aa63c10c29.svg";
export { ForwardRef as ReactComponent };